import { createEnumType } from 'acscp/api/models/customTypes/enumUtils';

export enum VolumeUnit {
    CubicMetre = 'CubicMetre',
    CubicFoot = 'CubicFoot',
}

export const VolumeUnitDynamicType =  createEnumType('VolumeUnit', VolumeUnit);
